module.exports = __webpack_public_path__ + "static/media/arrow-trend-up-solid.8966dfa4.svg";